define([
	'jquery',
	'responsive_devicemenu',
	'responsive_mainsearch',
	'responsive_common',
	'responsive_footer',
	'responsive_mainmenu',
	'responsive_countries',
	'common'
], function ($, ResponsiveDeviceMenu, ResponsiveMainSearch, ResponsiveCommon, ResponsiveFooter, ResponsiveMainMenu, ResponsiveCountries, ERVCommon) {
	var Responsive = function () {
		var self = this;
		self.$ervBody = $('#erv-body');
		self.common = new ERVCommon();

		self.$window = $(window);
		self.width = self.$window.width();
		self.deviceSize = '';
		self.$ervBody = $('#erv-body');

		self.fixDateNoClickBookingWidget = function (add) {
			var $dateInputContainers = self.$ervBody.find('#booking-widget .is-date'),
				$dateInputs = $dateInputContainers.find('input'),
				$dateIcons = $dateInputContainers.find('.date-icon');

			if (add) {
				$dateInputs.on('touchstart', function (e) {
					e.preventDefault();
					$(this).blur();
				});
				$dateInputs.attr('readonly', 'on');
				$dateInputs.addClass('noclick');
				$dateIcons.addClass('noclickfix');

				var $readonlyDateInput = self.$ervBody.find('#booking-widget .is-date input[readonly]');
				$readonlyDateInput.on('focus', function () { $(this).blur(); });
			} else {
				$dateInputs.off('touchstart');
				$dateInputs.removeAttr('readonly');
				$dateInputs.removeClass('noclick');
				$dateIcons.removeClass('noclickfix');
			}
		}

		self.resizeSmall = function($bookingWidgetSelectProduct, $tableCompareContainers) {
			self.deviceMenu.initSmallerDevice();
			self.mainSearch.initSmallDevice();
			self.footer.addEventListener();
			self.mainMenu.initSmallerDevice();
			self.countries.initSmallDevice();

			if (self.$ervBody.find('#booking-widget').length) {
				self.responsiveCommon.addEventListener($bookingWidgetSelectProduct);
				self.fixDateNoClickBookingWidget(true);
			}

			self.setBookingSummaryDetails(false);

			if ($tableCompareContainers.length) {
				self.responsiveTable.initSmall($tableCompareContainers);
			}
		}

		self.resizeMedium = function($bookingWidgetSelectProduct, $tableCompareContainers) {
			self.deviceMenu.initSmallerDevice();
			self.mainSearch.initLargerDevice();
			self.footer.removeEventListener();
			self.mainMenu.initSmallerDevice();
			self.countries.initLargerDevices();

			if (self.$ervBody.find('#booking-widget').length) {
				self.responsiveCommon.addEventListener($bookingWidgetSelectProduct);
			}

			self.setBookingSummaryDetails(false);

			if ($tableCompareContainers.length) {
				self.responsiveTable.initLarger($tableCompareContainers);
			}
		}

		self.resizeLarge = function($bookingWidgetSelectProduct, $tableCompareContainers) {
			self.deviceMenu.initLargeDevice();
			self.mainSearch.initLargerDevice();
			self.footer.removeEventListener();
			self.mainMenu.initLargeDevice();
			self.countries.initLargerDevices();

			if (self.$ervBody.find('#booking-widget').length) {
				self.responsiveCommon.removeEventListener($bookingWidgetSelectProduct);
				$bookingWidgetSelectProduct.addClass('wide');
			}

			self.setBookingSummaryDetails(true);

			if ($tableCompareContainers.length) {
				self.responsiveTable.initLarger($tableCompareContainers);
			}
		}

		self.doneResizing = function () {
			var deviceSize = self.responsiveCommon.getDeviceSize(),
				$bookingWidgetSelectProduct = self.$ervBody.find('.bookingselectproductpage #booking-widget'),
				$tableCompareContainers = self.$ervBody.find('.table-compare-container');

			if (self.$ervBody.find('#booking-widget').length) {
				self.fixDateNoClickBookingWidget(false);
			}

			if (deviceSize === self.responsiveCommon.small) {
				self.resizeSmall($bookingWidgetSelectProduct, $tableCompareContainers);
			} else if (deviceSize === self.responsiveCommon.medium) {
				self.resizeMedium($bookingWidgetSelectProduct, $tableCompareContainers);
			} else if (deviceSize === self.responsiveCommon.large) {
				self.resizeLarge($bookingWidgetSelectProduct, $tableCompareContainers);
			}
		}

		self.setBookingSummaryDetails = function (isLargeBreakpoint) {
			var $bookingsummarydetails = self.$ervBody.find('#booking-summary #details');

			if ($bookingsummarydetails.length === 0) {
				return;
			}

			var $toggle = $bookingsummarydetails.find('[data-js="read-toggle"]').first();
			var isVisibleAtStart = $toggle.data('is-visible-at-start') === 'True';
			var isClosed = $bookingsummarydetails.find('[data-js="read-target"]').hasClass('hide');

            var shouldOpen = isVisibleAtStart && isLargeBreakpoint;

			if (shouldOpen && isClosed || !shouldOpen && !isClosed) {
                $toggle.click();
			}
		}

        self.fixedMode = function () {
            var $body = $('body');
            var FIXED_MODE_CSS_CLASS = 'fixed-mode';
			var HIDE_SECTION_PICKER_CSS_CLASS = 'hide-section-picker';
            var THRESHOLD = 50;

            var hasSectionPicker = !!$('[data-js=section-picker]').length;
            var cssClass = FIXED_MODE_CSS_CLASS + (hasSectionPicker ? ' ' + HIDE_SECTION_PICKER_CSS_CLASS : '');
            var isLargeDevice = self.deviceSize === self.responsiveCommon.large;
			var pageScrollTop = window.pageYOffset || document.documentElement.scrollTop;

            if (isLargeDevice) {
                if (pageScrollTop > THRESHOLD && $('.mainmenu:visible').length) {
                    return $body.addClass(cssClass);
                } 
                return $body.removeClass(cssClass);
            } 
            return $body.addClass(cssClass);
        };

		self.fixSwipe = function (size) {
			if (self.$ervBody.find('.swipe, .had-swipe').length && size === self.responsiveCommon.small && ('ontouchstart' in window) || !!(navigator.msMaxTouchPoints)) {
				require(['responsive_swipe'],
					function(moduleName) {
						self.swipe = new (moduleName);
						self.swipe.init();
					});
			} else if (typeof(self.swipe) !== 'undefined') {
				self.swipe.remove();
			} else {
				self.$ervBody.find('.swipe').removeClass('swipe');
				self.$ervBody.find('.swipe-indicator').addClass('hide');
			}
		};
	};

	Responsive.prototype.init = function () {
		var self = this;

		self.deviceMenu = new ResponsiveDeviceMenu(self.$ervBody.find('header'));
		self.mainSearch = new ResponsiveMainSearch(self.$ervBody.find('header'));
		self.responsiveCommon = new ResponsiveCommon();
		self.mainMenu = new ResponsiveMainMenu();
		self.footer = new ResponsiveFooter(self.$ervBody.find('footer .link-list [data-js="expandtrigger"]'));
		self.countries = new ResponsiveCountries();
		self.responsiveTable = self.responsiveCommon.responsiveTable;

		self.doneResizing();

        var width = self.$window.width(),
			deviceSize = self.responsiveCommon.getDeviceSize(),
			resizeId;

		self.deviceSize = deviceSize;

		self.fixSwipe(self.deviceSize);

		self.mql = window.matchMedia && window.matchMedia('(orientation: portrait)');

		// Add a media query change listener
		if (self.mql) {
			self.mql.addListener(function (m) {
				self.fixSwipe(self.responsiveCommon.getDeviceSize());
			});
		}

		self.$window.resize(function () {
			var newWidth = self.$window.width();

			if (width !== newWidth) {
				width = newWidth;

				clearTimeout(resizeId);
				resizeId = setTimeout(function () {
					var changedDeviceSize = self.responsiveCommon.getDeviceSize();

					if (deviceSize !== changedDeviceSize) {
						deviceSize = changedDeviceSize;
						self.deviceSize = deviceSize;

						self.doneResizing();
					}

                    self.common.framework.equalizeParent($('#guide .group'));

                    self.common.framework.equalizeTeasers();

					self.fixedMode();

					self.mql = window.matchMedia && window.matchMedia('(orientation: portrait)');

				}, 200);
			}
		});

		self.fixedMode();

		self.$window.on('scroll', function () {
			setTimeout(function () {
				self.fixedMode();
			}, 200);
		});
	}

	return Responsive;
});